export const PREVIEW_HEARTBEAT_MS = 60 * 1000;

export function isPreviewTabActive(visibilityState: string): boolean {
  return visibilityState === 'visible';
}

export function shouldEnsureSessionPreview(
  visibilityState: string,
  previewStatus: 'live' | 'off'
): boolean {
  return isPreviewTabActive(visibilityState) && previewStatus === 'off';
}
